import React from 'react';
import Logo from '../images/Stellosysy-Logo-sign.svg';
import '../styles/Footer.scss';
import { useTranslation } from 'react-i18next';



export default function Footer() {
    const { t } = useTranslation();
    
    return (
        <footer>
            <div className="footer-bottom">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <p className="power">{t('Powered by')}</p>
                            <img src={Logo} className="stellosys-logo" alt="" />
                        </div>
                        <div className="col-md-6">
                            <div className="contact-second">
                                <p>{t('Copyright 2020 Stellosys')}<br />{t('All rights Reserved')}.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}